var link_viewer_default = {
  "fontElementMap": "_9MG5B",
  "link": "ZbI--",
  "linkInEditor": "yTBI-",
  "linkInViewer": "mzSg8",
  "toolbarUrlContainer": "Q4TZ0",
  "toolbarUrl": "IM7Sq",
  "toolbarUrlAnchor": "TkYTL"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
